import GET_C8_CATALOG_ITEM from './getC8CatalogItem.graphql'
export {GET_C8_CATALOG_ITEM}


// WEBPACK FOOTER //
// ./src/stores/c8/graphql/index.ts